//-- Copyright (c) 2021 TMT Insights Group, LLC
import { Breadcrumbs, Title, TitleBar } from '@/components/_common';
import { selectDataTableAppliedSearchName } from '@/redux/selectors/dataTableSelectors';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { selectCanWriteProfiles } from '../../redux/selectors/authSelectors';
import PolarisIcon from '../_common/PolarisIcon';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const ProfileTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const canCreateProfile = useAppSelector(selectCanWriteProfiles);

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>Customer Profiles</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/profiles" onClick={onBreadcrumbClick}>
              Customer Profiles
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}

        {canCreateProfile && (
          <Button variant="contained" color="primary" component={Link} to="/profiles/new" startIcon={<PolarisIcon icon="add" height={15} />}>
            New Profile
          </Button>
        )}
      </Grid>
    </TitleBar>
  );
};

export default ProfileTitleBar;
